module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-coins-xl-81e464aafc50cde86b14650bc1930510.svg";